import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';

// Components
import SVG from 'components/widgets/icons/svg';


export default function Archive({ triageItem, updateTriageItem }) {
  return (
    <li
      onClick={() => updateTriageItem({ id: triageItem.id, status: 'Archived' })}
      className={classNames('triage-option-archive', { disabled: !_.isEmpty(triageItem.ticket) }, 'triage-option-header')}
    >
      <SVG src="svg/delete.svg" className="triage-option-icon archive" />
    </li>
  );
}

Archive.propTypes = {
  triageItem: PropTypes.object.isRequired,
  updateTriageItem: PropTypes.func.isRequired
};
